import { ModalFactory, type ModalConfig } from '@rendora/common/features/modals/factory';
import { getI18nService } from '@rendora/common/services/i18n';
import { useBreakpoint } from '@rendora/design/utils/responsive';
import SwitchAccount from './SwitchAccount.vue';
import SwitchAccountMobile from './SwitchAccountMobile.vue';

export interface SwitchAccountModalConfig {
  title?: string;
  width?: string | number;
  onLoginSuccess?: () => void;
}

export class SwitchAccountModalFactory {
  static modalSymbol = Symbol('switch-account-modal');

  static create(config: SwitchAccountModalConfig) {
    const i18nService = getI18nService();
    const $t = i18nService.t;

    const { isMobile } = useBreakpoint();

    const Content = isMobile.value ? SwitchAccountMobile : SwitchAccount;
    const defaultTitle = isMobile.value ? $t('zhu-zhang-hao-xuan-ze') : $t('qie-huan-zhang-hao');

    const modalConfig: ModalConfig = {
      title: config.title ?? defaultTitle,
      width: config.width || (isMobile.value ? '89vw' : '400px'),
      height: isMobile.value ? '71.36vh' : undefined,
      borderRadius: isMobile.value ? '8px' : undefined,
      content: <Content onLoginSuccess={config.onLoginSuccess}></Content>,
    };

    return ModalFactory.create(modalConfig, SwitchAccountModalFactory.modalSymbol);
  }
}

// 便捷方法
export const showSwitchAccountModal = (config: SwitchAccountModalConfig) => {
  return SwitchAccountModalFactory.create(config);
};
